import { render, staticRenderFns } from "./FormRulesEdit.vue?vue&type=template&id=01e1b95b"
import script from "./FormRulesEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./FormRulesEdit.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormRulesEdit.vue?vue&type=style&index=0&id=01e1b95b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports